/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

(function() {
  var searchRedirectTimer = null;

  function buildProductSearchUrl(term) {
    return '/search?q=' + encodeURIComponent(term) + '&type=product';
  }

  function redirectToProductSearch(term) {
    var cleanTerm = String(term || '').replace(/\s+/g, ' ').trim();

    if (cleanTerm.length < 2) {
      return;
    }

    window.location.href = buildProductSearchUrl(cleanTerm);
  }

  document.addEventListener('input', function(event) {
    var input = event.target;

    if (!input || !input.matches || !input.matches('#Search .Search__Input[name="q"]')) {
      return;
    }

    window.clearTimeout(searchRedirectTimer);
    searchRedirectTimer = window.setTimeout(function() {
      redirectToProductSearch(input.value);
    }, 650);
  }, true);

  document.addEventListener('submit', function(event) {
    var form = event.target;

    if (!form || !form.matches || !form.matches('#Search .Search__Form')) {
      return;
    }

    var input = form.querySelector('.Search__Input[name="q"]');

    if (!input) {
      return;
    }

    event.preventDefault();
    redirectToProductSearch(input.value);
  }, true);
}());

(function () {
  function setPix(element, cents, label) {
    if (!element) return;
    element.hidden = !Number.isFinite(Number(cents));
    if (element.hidden) return;
    var currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'BRL';
    var formatted = new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', {
      style: 'currency', currency: currency || 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2
    }).format(Math.round(Number(cents) * 90 / 100) / 100);
    var amount = element.querySelector('[data-courum-pix-amount]');
    if (!amount) {
      element.textContent = '';
      amount = document.createElement('span');
      amount.setAttribute('data-courum-pix-amount', '');
      amount.setAttribute('data-money-convertible', '');
      element.appendChild(amount);
      element.appendChild(document.createTextNode(' '));
      var paymentLabel = document.createElement('span');
      paymentLabel.className = 'CourumPixLabel';
      paymentLabel.textContent = label;
      element.appendChild(paymentLabel);
    }
    element.classList.add('CourumPixPrice');
    element.removeAttribute('data-money-convertible');
    element.setAttribute('data-courum-pix-price', String(cents));
    amount.textContent = formatted;
  }
  document.addEventListener('variant:changed', function (event) {
    var scope = event.target.closest('[id^="shopify-section-"]') || event.target;
    var variant = event.detail && event.detail.variant;
    var list = scope.querySelector('.ProductMeta__PriceList');
    var primary = list && list.querySelector('.Price:not(.Price--compareAt)');
    var sticky = scope.querySelector('.CourumStickyBuy__Pix');
    if (!variant) {
      if (primary) primary.hidden = true;
      if (sticky) sticky.hidden = true;
      return;
    }
    var label = list && list.getAttribute('data-courum-pix-label') || 'no Pix';
    if (primary) primary.classList.add('ProductMeta__Pix');
    setPix(primary, variant.price, label);
    setPix(sticky, variant.price, label);
  });
}());
